export default __webpack_public_path__ + "static/media/qrCode.d3dad6dc.png";